import React from 'react'
import ScaleLoader from "react-spinners/ScaleLoader";
import './loading.css'
import { css } from "@emotion/core";

function Loading(props){
    const override = css`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
    
    
    `;
    return(
        <div className={'spinner'}>
        <ScaleLoader color={'#17a2b8'}  css={override} loading={true}  />
        </div>
    )
}

export default Loading